//loaders
export const LOGIN_ENABLE_LOADER = 'LOGIN_ENABLE_LOADER';
export const LOGIN_DISABLE_LOADER = 'LOGIN_DISABLE_LOADER';

// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOG_OUT = 'LOG_OUT';
export const CHANGE_ACADEMIC_SESSION = 'CHANGE_ACADEMIC_SESSION';
export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const FORGETPASS_SWIPE = 'FORGETPASSSWIPE';
export const GENERATEPASS_SWIPE = 'GENERATEPASS_SWIPE';
export const LOGIN_DATA = 'LOGIN_DATA';
export const APPLICATION_NUMBER = 'APPLICATION_NUMBER';
// Download
export const DOWNLOAD_RESPONSE = 'DOWNLOAD_RESPONSE';
export const DOWNLOAD_DETAIL_RESPONSE = 'DOWNLOAD_DETAIL_RESPONSE';

// Notice Board and NoticeBoard Detail
export const NOTICEBOARD_RESPONSE = 'NOTICEBOARD_RESPONSE';
export const NOTICEBOARD_DETAIL_RESPONSE = 'NOTICEBOARD_DETAIL_RESPONSE';

// Home Work
export const HOMEWORK_RESPONSE = 'HOMEWORK_RESPONSE';
export const HOMEWORK_DETAILS_RESPONSE = 'HOMEWORK_DETAILS_RESPONSE';

// Regular Exam Calendar
export const REGULAR_EXAM_RESPONSE = 'REGULAR_EXAM_RESPONSE';

// Digital Class
export const DIGITAL_CLASS_RESPONSE = 'DIGITAL_CLASS_RESPONSE';
export const DIGITAL_VIDEO_RESPONSE = 'DIGITAL_VIDEO_RESPONSE';
export const REDIRECT_CLASS = 'REDIRECT_CLASS';
export const TIMER = 'TIMER';

// Digital Class Material
export const CLASS_MATERIAL_RESPONSE = 'CLASS_MATERIAL_RESPONSE';
export const CLASS_MATERIAL_DOWNLOADS = 'CLASS_MATERIAL_DOWNLOADS';

// Batch Class Schedule
export const BATCH_CLASS_RESPONSE = 'BATCH_CLASS_RESPONSE';

// Digital Doubt Counter
export const DOUBT_TOPIC_RESPONSE = 'DOUBT_TOPIC_RESPONSE';
export const FETCH_QUESTION_LIST_RESPONSE = 'FETCH_QUESTION_LIST_RESPONSE';
export const FETCH_MEMBER_LIST_RESPONSE = 'FETCH_MEMBER_LIST_RESPONSE';
export const FETCH_COMMENT_LIST_RESPONSE = 'FETCH_COMMENT_LIST_RESPONSE';
export const INSERT_QUESTION_ITEM_RESPONSE = 'INSERT_QUESTION_ITEM_RESPONSE';
export const INSERT_COMMENT_ITEM_RESPONSE = 'INSERT_COMMENT_ITEM_RESPONSE';
export const INSERT_STUDENT_COMMENT_ITEM_RESPONSE = 'INSERT_STUDENT_COMMENT_ITEM_RESPONSE';

// Snackbar
export const SNACKBAR_OPEN = 'SNACKBAR_OPEN';
export const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE';

// Race And Exercise
export const EXERCISE_DROPDOWN = 'EXERCISE_DROPDOWN';
export const SUBJECT_DROPDOWN = 'SUBJECT_DROPDOWN';
export const WORKBOOK_DETAILS = 'WORKBOOK_DETAILS';

// Digital LiveClass
export const DIGITAL_LIVE_CLASS_RESPONSE = 'DIGITAL_LIVE_CLASS_RESPONSE';
export const LIVE_CLASS_PLAYER_RESPONSE = 'LIVE_CLASS_PLAYER_RESPONSE';

// Dashboard
export const DASHBOARD_RESPONSE = 'DASHBOARD_RESPONSE';
export const LOGIN_PROFILE_RESPONSE = 'LOGIN_PROFILE_RESPONSE';

//Digital Discussion
export const DISCUSSION_DROPDOWN = 'DISCUSSION_DROPDOWN';
export const CLASS_PLAYER = 'CLASS_PLAYER';

//Cbse class
export const CBSE_CLASS = 'CBSE_CLASS';
export const CBSE_CLASS_PLAYER = 'CBSE_CLASS_PLAYER';
//Dashboard
export const DASH_BOARD = 'DASH_BOARD';

// Teacher Doubt
export const TEACHER_DOUBT_TOPIC_RESPONSE = 'TEACHER_DOUBT_TOPIC_RESPONSE';
export const TEACHER_FETCH_QUESTION_LIST_RESPONSE =
  'TEACHER_FETCH_QUESTION_LIST_RESPONSE';
export const TEACHER_FETCH_COMMENT_LIST_RESPONSE =
  'TEACHER_FETCH_COMMENT_LIST_RESPONSE';

// Doubt Moderator
export const DOUBT_MOD_RESPONSE = 'DOUBT_MOD_RESPONSE';

//Performance Record
export const PERFORMANCE_RECORD = 'PERFORMANCE_RECORD';

// Test Performance Analysis
export const PERFORMANCE_ANALYSIS = 'PERFORMANCE_ANALYSIS';
export const TEST_RESULT = 'TEST_RESULT';
export const TEST_ANALYSIS_PAPER_1 = 'TEST_ANALYSIS_PAPER_1';
export const TEST_ANALYSIS_PAPER_2 = 'TEST_ANALYSIS_PAPER_2';
export const TEST_SOLUTION_PAPER_1 = 'TEST_SOLUTION_PAPER_1';
export const TEST_SOLUTION_PAPER_2 = 'TEST_SOLUTION_PAPER_2';
export const TEST_OMR_1 = 'TEST_OMR_1';
export const TEST_OMR_2 = 'TEST_OMR_2';

// Welcome Screen
export const HIDE_WELCOME_SCREEN = 'HIDE_WELCOME_SCREEN';

// Video Player
export const VIDEO_PLAYER_ORENTATION = 'VIDEO_PLAYER_ORENTATION';

// Live Class Recordings
export const LIVE_CLASS_RECORDINGS = 'LIVE_CLASS_RECORDINGS';
export const LIVE_CLASS_RECORDINGS_PLAYER = 'LIVE_CLASS_RECORDINGS_PLAYER';

// Live Webinar
export const LIVE_WEBINAR_LIST_RESPONSE = 'LIVE_WEBINAR_LIST_RESPONSE';
export const LIVE_WEBINAR_PLAYER_RESPONSE = 'LIVE_WEBINAR_PLAYER_RESPONSE';

// Text Message
export const TEXTMSG_RESPONSE = 'TEXTMSG_RESPONSE';

// Exam Hall
export const EXAM_HALL_LIST_RESPONSE = 'EXAM_HALL_LIST_RESPONSE';
export const EXAM_HALL_PLAYER_RESPONSE = 'EXAM_HALL_PLAYER_RESPONSE';

// Live Doubt Class
export const LIVE_DOUBT_CLASS_RESPONSE = 'LIVE_DOUBT_CLASS_RESPONSE';
export const LIVE_DOUBT_CLASS_DETAIL_RESPONSE =
  'LIVE_DOUBT_CLASS_DETAIL_RESPONSE';

// Group Notification
export const GROUP_NOTIFICATION_LIST = 'GROUP_NOTIFICATION_LIST';
